var map = {
	"./Action-Figure-Folds.png": 9812,
	"./Action-Figure-Labels.png": 91008,
	"./Action-Figure.png": 88449,
	"./Background.png": 11651,
	"./Folds.png": 95723,
	"./Labels.png": 48314,
	"./Tabs.png": 25905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2270;